import { UserCreate, UserPrivate, UsersOrderBy, UsersService, UserUpdate } from "../client"

/* Interfaces */
export interface AddUserProps {
    onClose: () => void
    isOpen: boolean
}

export interface EditUserProps {
    onClose: () => void
    isOpen: boolean
    user: UserPrivate
}

export interface UpdateUserProps extends UserUpdate {
    confirm_password: string
}

export interface DetailUserProps {
    onClose: () => void
    isOpen: boolean
    user: UserPrivate | null
}

export interface UserMenuProps {
    onClose?: () => void
}

export interface AddUserFormProps extends UserCreate {
    confirm_password: string
}


/* Endpoints */
export const readUsers = ({
    per_page,
    page,
    order_by,
    descending,
    query,
}: {
    per_page: number,
    page: number
    order_by?: UsersOrderBy
    descending?: boolean
    query?: string
}) => {
    return {
        queryFn: async () => {
            const data = await UsersService.readUsers({
                skip: (page - 1) * per_page,
                limit: per_page,
                orderBy: order_by,
                descending: descending,
                query: query,
            })

            return data ?? { data: null, count: 0 }
        },
    queryKey: ["users", { page, order_by, descending, query }],
    }
}
